<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 3"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header" v-if="!disabled">
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="$emit('add')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="$emit('chooseSample')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('btn_select_sample') || '选择已有样品' }}
          </b-button>
        </slot>
      </template>

      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:specInfo="{ row }">
        {{ row.sampleSpec }} {{ row.v_sampleSizeUnit }}
      </template>
      <template v-slot:weightInfo="{ row }">
        {{ row.sampleWeight }} {{ row.v_sampleWeightUnit }}
      </template>
      <template v-slot:moqInfo="{ row }">
        {{ row.moq }} {{ row.v_moqUnit }}
      </template>
      <template v-slot:quotedPriceInfo="{ row }">
        {{ row.quotedPrice }} {{ row.v_quotedCurrency }}
      </template>
      <template v-slot:costPriceInfo="{ row }">
        {{ row.costPrice }} {{ row.v_costCurrency }}
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.sampleStatus === 'Y' ? '' : 'success'">
          {{ row.v_sampleStatus }}
        </el-tag>
      </template>
      <template v-slot:done="{ row }">
        <el-tag size="mini" :type="row.isDone === 'Y' ? 'success' : 'info'">
          {{ row.v_isDone }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openSampleDialog', {
                  type: 'detail',
                  params: { sampleCode: row.sampleCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="row.isDone === 'N' && !disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openSampleDialog', {
                  type: 'edit',
                  params: { sampleCode: row.sampleCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_success') || '完成'"
            placement="top"
            v-if="
              (row.proofingStatus === 'Y' || row.proofingStatus === 'W') &&
                row.isDone === 'N'
            "
          >
            <i
              class="el-icon-finished tool-btn"
              @click="finish(row.sampleCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            v-if="row.isDone === 'N' && !disabled"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.sampleCode)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(sampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.proofingSampleInfoDelApi({ sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    copy(sampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_copy') || '是否要复制该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.proofingSampleInfoCopyApi({ sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    audit(sampleCode) {
      this.$confirm(
        this.$l('INDEX.tips_audit') || '是否要审核该样品记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.proofingSampleInfoAuditApi({ sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    finish(sampleCode) {
      this.$confirm(
        this.$l('tips_finish') || '是否要确认完成该依赖书样品并导入样品库？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.proofingSampleInfoFinishApi({ sampleCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
